import {CFGroupEpic} from 'module/CFGroup/epic/CFGroupEpic'
import {Module} from 'module/Module'
import {CFGroupReducerNS} from 'module/CFGroup/reducer/CFGroupReducer'

export const CFGroupModule: Module = {
	reducerNS: CFGroupReducerNS,
	epics: [CFGroupEpic],

}